/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Weeks = 'Website.Countdown.Weeks';
export const Days = 'Website.Countdown.Days';
export const Hours = 'Website.Countdown.Hours';
export const Minutes = 'Website.Countdown.Minutes';
export const Seconds = 'Website.Countdown.Seconds';
export const MinutesShort = 'Website.Countdown.MinutesShort';
export const SecondsShort = 'Website.Countdown.SecondsShort';
export const OfferExpiresIn = 'Website.Countdown.OfferExpiresIn';
export const ExpiresIn = 'Website.Countdown.ExpiresIn';
